module.exports = __webpack_public_path__ + "mt.svg?d96e7a618510c4ebd369579d68df5932";